let _config = null;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Retries past a transient failure (network blip, backend mid-restart during
// a deploy) instead of caching it — a bad guess here commits the whole app to
// NoAuthProvider, whose getAccessToken/forceReLogin are no-ops, so a 401
// afterwards has no recovery path at all.
export async function fetchAuthConfig() {
  if (_config) return _config;
  const attempts = 3;
  for (let i = 0; i < attempts; i++) {
    try {
      const res = await fetch('/api/auth-config');
      if (!res.ok) throw new Error(res.status);
      _config = await res.json();
      return _config;
    } catch (err) {
      if (i === attempts - 1) {
        console.warn('[auth] auth-config fetch failed after retries, falling back to no-auth mode:', err?.message || err);
        return { enabled: false, tenantId: null, clientId: null };
      }
      await sleep(500 * (i + 1));
    }
  }
}

export function buildMsalConfig(tenantId, clientId) {
  return {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  };
}

export function buildLoginRequest() {
  return { scopes: ['openid', 'profile', 'email'] };
}
